<template>
    <span>{{name}}</span>
</template>

<script>
export default {
    name: "filter-span",
    props: {
        filterArray: Array,
        selectId: Number
    },
    data: function() {
        return {
            name: ""
        };
    },
    created() {
        if (this.filterArray.length > 0) {
            for (let i = 0; i < this.filterArray.length; i++) {
                if (this.filterArray[i].id == this.selectId) {
                    this.name = this.filterArray[i].name;
                    break;
                }
            }
        }
    },
    watch: {
        filterArray(value) {
            if (value.length > 0) {
                for (let i = 0; i < value.length; i++) {
                    if (value[i].id == this.selectId) {
                        this.name = value[i].name;
                        break;
                    }
                }
            }
        },
        selectId(id){
            if (this.filterArray.length > 0) {
                for (let i = 0; i < this.filterArray.length; i++) {
                    if (this.filterArray[i].id == id) {
                        this.name = this.filterArray[i].name;
                        break;
                    }
                }
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/filterSpan/filterSpan.vue